// src/login.js
import { api } from './api';
export function login(username, password) {
  return api('/api/auth/login', { method: 'POST', headers: {'content-type':'application/json'}, body: JSON.stringify({ username, password }) });
}
